'use strict';

Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.stringable = stringable;

function stringable(thing) {
    return thing !== null && typeof thing !== 'undefined' && typeof (thing.toString === 'function');
}



//////////////////
// WEBPACK FOOTER
// ../~/reactable/lib/reactable/lib/stringable.js
// module id = 590
// module chunks = 0